// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/animation.less
// module id = 1
// module chunks = 0